import DOMPurify from 'dompurify'

// 校验字符串内容是否符合富文本格式  不符合自动补充
export function validateHtml(htmlString: string): string {
    try {
        const clean = DOMPurify.sanitize(htmlString, { FORBID_TAGS: ['style'] })
        return clean
    } catch (error) {
        return htmlString
    }
}

